import { EventsInteractionsTracker } from './eventInteractionsTracker';
import { InteractionsLoggerV1 } from './interactionsLoggerV1';
import { InteractionsPicoXLogger } from './interactionsPicoXLogger';

let eventInteractionTracker: EventsInteractionsTracker;

/**
 * Boots the singleton document-level interaction tracker for the page.
 *
 * Registers both sinks on the SAME tracker so they consume the identical
 * deduped, batched interaction stream — a duplicate impression dropped for
 * engagement is dropped for PicoX too, keeping ad spend 1:1 with engagement:
 *   - `InteractionsLoggerV1` — Core engagement (`/api/v3/log_engagement/`).
 *   - `InteractionsPicoXLogger` — PicoX promoted-event spend pipeline
 *     (`ads_promoted_eb_event_impression` / `_click`, product_location 'homepage').
 */
export function startEventCardTracking() {
    const IS_SSR = typeof document === 'undefined';

    if (IS_SSR || eventInteractionTracker) {
        return;
    }

    eventInteractionTracker = new EventsInteractionsTracker(document, [
        new InteractionsLoggerV1(),
        new InteractionsPicoXLogger(),
    ]);

    eventInteractionTracker.listen();
    eventInteractionTracker.track();
}
